import { CampoDeFecha } from '../../../nucleo/fecha/CampoDeFecha.jsx';
import { obtenerFechaDeNegocioHoy } from '../../../nucleo/fecha/fechaLocal.js';
import { CampoDeImporte } from '../../../nucleo/importes/CampoDeImporte.jsx';
import { importe as formatearImporte } from '../formato.js';
import { ComboboxDeCuenta } from './ComboboxDeCuenta.jsx';
import { SelectorConBuscador } from './SelectorConBuscador.jsx';
import { PERFIL_DE_CATEGORIA } from '../logica/perfilesDeSelector.js';

/**
 * Campos compartidos por las tres capturas de una sola cuenta: gasto, ingreso y
 * devolución (RF-048, RF-049, RF-063).
 *
 * ESTÁ AQUÍ Y NO REPETIDO TRES VECES por una razón concreta: son cinco campos y
 * ninguno más, y si cada pantalla los declarara por su cuenta acabarían siendo
 * cinco, seis y siete (RF-048). Lo que cambia entre pantallas es el catálogo de
 * categorías, los textos y si se ofrece la casilla de meses sin intereses.
 *
 * ESTA PANTALLA NO CALCULA NADA (RNF-030, prueba 45): no suma saldos, no deriva
 * periodos y no decide fechas. Muestra lo que el servidor devuelve y envía la
 * fecha local del dispositivo tal cual (D-06, RN-075a).
 */
export function CamposDeCaptura({
  etiquetaDeCategoria,
  categorias,
  idCategoria,
  alElegirCategoria,
  etiquetaDeCuenta,
  cuentas,
  idCuenta,
  alElegirCuenta,
  /* RF-187 · Indicador de carga de la lista de cuentas. OPCIONAL: sin él vale falso
     y esta pantalla se comporta igual que antes de la rev. 11 (CA-11-40). */
  cargandoCuentas = false,
  /* RF-187 · Lo mismo para el catálogo de categorías, que desde el 17 también se
     elige con el control único y por tanto también necesita declarar su estado de
     carga (RN-655). OPCIONAL, por omisión falso. */
  cargandoCategorias = false,
  importe,
  alEscribirImporte,
  /*
   * T-17-02 · H-20 (RF-235, RF-236, RN-659 a RN-662, D-359). ¿ESTE MONTAJE DEL
   * CAMPO DE IMPORTE DEBE LLEVARSE EL FOCO? OPCIONAL, por omisión verdadero: en el
   * ALTA vale siempre verdadero y el campo se comporta EXACTAMENTE como antes
   * (CA-17-08). En la EDICIÓN la pantalla lo pone en falso mientras el movimiento
   * no ha llegado, y lo sube a verdadero cuando el importe guardado YA ESTÁ
   * PRESENTADO: el foco no se adelanta al dato (RN-660).
   */
  tomarElFocoDelImporte = true,
  fecha,
  alElegirFecha,
  nota,
  alEscribirNota,
  ofreceMesesSinIntereses = false,
  mesesSinIntereses = false,
  alMarcarMesesSinIntereses,
  ayuda,
}) {
  /*
   * RN-566 · LA LISTA SIGUE SIENDO UN ARREGLO, NUNCA NULA, y por eso este
   * `find` sigue escrito igual y sigue funcionando durante la carga: devuelve
   * `undefined` sobre la lista vacía, como siempre. Es exactamente el sitio por el
   * que se descartó distinguir «no llegó» de «llegó vacía» por el valor (D-298).
   */
  const cuenta = cuentas.find((c) => c.idCuenta === idCuenta);
  const hoy = obtenerFechaDeNegocioHoy();

  return (
    <>
      <div className="card" style={{ margin: 12 }}>
        <label className="ayuda" htmlFor="importe">IMPORTE</label>
        {/* Regla única de campos de importe (RF-086): selecciona al enfocar,
            formatea al salir y rechaza divisa cruzada, negativo, tres decimales y
            texto. La divisa la pone la CUENTA, no la persona (D-39, RN-051).

            CAMPO CONGELADO · NO SE TOCA (D-229, RN-373 a RN-375).
            El incremento 08 cambió aquí SOLO texto —se retiró el «(D-39)» que la
            ayuda de abajo citaba en pantalla (RN-332)—. Lo que queda prohibido
            cambiar, por decisión cerrada del 2026-10-03:
              · el `autoFocus` NO se retira: el campo recibe el foco al abrir;
              · NO se pasa valor inicial: en un gasto nuevo el campo arranca
                VACÍO, y vacío se pinta vacío (ni «0.00» ni raya);
              · NO se agrega ninguna propiedad nueva al campo;
              · la autoselección al enfocar es intencional (RN-135, incremento 3)
                y se queda.
            El `value="0.00"` que dibuja diseno/prototipo-v24-captura.html es
            RECURSO DE DIBUJO del prototipo, NO requerimiento (RN-375): sirve para
            que la pantalla y el aviso de error se lean. El prototipo del 08 vale
            para textos, etiquetas y acomodo; no autoriza valor inicial, foco ni
            selección. La no regresión se afirma en
            __tests__/importe-captura-no-regresion.test.jsx (RNF-074). */}
        {/* T-17-02 · LO ÚNICO QUE EL 17 DESCONGELA, Y ES ORDEN DE SUCESOS, NO
            CONDUCTA DEL CAMPO (D-359, RN-662): en la EDICIÓN el foco automático
            espera al dato. No se agrega ninguna propiedad nueva al campo, no se
            toca RN-135 y el alta no cambia en nada.

            POR QUÉ UNA `key` Y NO UN `focus()` DESDE UN EFECTO: `autoFocus` es
            cosa del MONTAJE, así que un campo montado sin foco no lo toma después
            por mucho que la propiedad cambie. Enfocarlo a mano exigiría una
            referencia al `input`, que `CampoDeImporte` no expone —y es del núcleo,
            que este incremento NO toca—. Con la `key` el campo se vuelve a montar
            UNA VEZ, cuando el importe guardado ya está presentado, y entonces su
            propio `autoFocus` dispara el `select()` diferido de RN-135: el valor
            queda marcado completo y un tecleo lo reemplaza entero (RF-236).

            Y POR QUÉ NO SE VUELVE A MONTAR SI LA PERSONA YA TECLEÓ (RN-661): la
            pantalla deja `tomarElFocoDelImporte` en falso en ese caso, así que la
            `key` NO cambia, no hay montaje nuevo y no se le quita el foco ni se le
            pisa lo escrito a quien llegó antes que el dato. */}
        <CampoDeImporte
          key={tomarElFocoDelImporte ? 'importe-con-foco' : 'importe-sin-foco'}
          id="importe"
          name="importe"
          autoFocus={tomarElFocoDelImporte}
          valor={importe}
          alCambiar={alEscribirImporte}
          codigoDivisa={cuenta?.codigoISO ?? null}
          contexto="esta cuenta"
          aria-label="Importe"
          style={{ fontSize: 30, fontWeight: 700, width: '100%' }}
        />
        <div className="ayuda">
          {cuenta
            ? `${cuenta.codigoISO} · la moneda la pone la cuenta, no tú`
            : 'La moneda la pone la cuenta'}
        </div>
      </div>

      <div className="card" style={{ margin: 12 }}>
        {/* T-17-01 · CAMBIA EL CONTROL, NO LA REGLA (RF-231, RF-232, D-366).
            Aquí vivía un `<select>` nativo con veintiuna opciones que había que
            recorrer con el dedo; ahora es EL MISMO control con buscador de los
            selectores de cuenta, con el PERFIL DE CATEGORÍA (datos y funciones
            puras, RN-651). Todo lo demás se conserva:
              · el texto de petición es el que ya existía, palabra por palabra;
              · la opción muestra SOLO el nombre, como antes (RF-232);
              · la categoría sigue siendo obligatoria y la lista llega ya filtrada
                por el servidor —tipo y solo activas—: el control no recorta nada
                (RN-653);
              · la categoría sugerida por «Registrar devolución» y la del
                movimiento en edición se reflejan igual (RN-657).
            Como `CamposDeCaptura` es el componente compartido de las tres
            capturas, la adopción cubre de una sola vez gasto, ingreso y devolución,
            en alta Y en edición (RF-231). */}
        <SelectorConBuscador
          id="idCategoria"
          etiqueta={etiquetaDeCategoria}
          perfil={PERFIL_DE_CATEGORIA}
          opciones={categorias}
          valor={idCategoria}
          alElegir={(elegida) => alElegirCategoria(elegida ?? null)}
          obligatorio
          /* RF-187 / RN-655 · Mientras el catálogo no llega, el rótulo y el campo
             YA ESTÁN aquí, deshabilitados, con el mismo texto de petición: no se
             afirma que no haya categorías y nada de lo de abajo se mueve cuando
             llegan (RN-563, RN-564). */
          cargando={cargandoCategorias}
          datoDePrueba="combobox-categoria-captura"
        />

        {/* H-19 · CAMBIA EL CONTROL, NO LA REGLA (RF-178, RF-180). El desplegable
            nativo pasa a ser el combobox con filtrado al teclear, que es el MISMO
            de los otros tres selectores de cuenta. Todo lo demás se conserva:
            RN-436 sigue valiendo —la cuenta llega VACÍA y hay que elegirla, también
            cuando hay una sola (RF-153, D-247)—, el texto de petición es el mismo
            palabra por palabra, y lo que ya se mostraba en la opción se conserva:
            los cuatro dígitos se AÑADEN (RN-544). */}
        <ComboboxDeCuenta
          id="idCuenta"
          etiqueta={etiquetaDeCuenta}
          cuentas={cuentas}
          valor={idCuenta}
          alElegir={(elegido) => alElegirCuenta(elegido ?? null)}
          textoDePeticion="Elige la cuenta…"
          obligatorio
          /* RF-187 · Mientras la lista no llega, el rótulo y el campo YA ESTÁN
             aquí, deshabilitados, con el MISMO texto de petición: no se pinta nada
             que afirme que no hay cuentas (RN-563) y nada de lo de abajo se mueve
             cuando llegan (RN-564). */
          cargando={cargandoCuentas}
          datoDePrueba="combobox-cuenta-captura"
        />

        <div className="campo">
          {/* T-01 de CR-10 (RF-155, RN-447, D-256). Aquí empezaba
              «Preseleccionada con la última que usaste en este dispositivo.», que
              RF-153 vuelve falsa el mismo día: se retiró LA FRASE COMPLETA, con su
              `<b>`, y NO se reemplazó por otra —la cuenta vacía se explica sola
              con «Elige la cuenta…» (RN-436), y un texto que dijera «ahora tienes
              que elegir» justificaría el diseño, que RN-442 prohíbe—. Las dos
              frases que siguen se conservan PALABRA POR PALABRA: son verdad y son
              útiles. La ayuda la comparten las tres capturas, así que el retiro
              vale para las tres de una sola vez (RN-447c). */}
          <span className="ayuda">
            Solo se ofrecen
            <b> cuentas tuyas y activas</b>: el dinero solo sale de lo tuyo. El selector es
            ayuda visual; el control real es del servidor.
          </span>
        </div>

        {/* La casilla SOLO aparece en un gasto con tarjeta de crédito (RN-084). */}
        {ofreceMesesSinIntereses && cuenta?.esCredito && (
          <div className="campo">
            <label htmlFor="esMesesSinIntereses">
              <input
                id="esMesesSinIntereses"
                name="esMesesSinIntereses"
                type="checkbox"
                checked={mesesSinIntereses}
                onChange={(evento) => alMarcarMesesSinIntereses(evento.target.checked)}
              />{' '}
              A meses sin intereses
            </label>
            <span className="ayuda">
              Se guarda como marca de la compra: la deuda sube por el importe total.
              ¿La compraste a meses sin intereses? Regístrala desde la tarjeta, en Planes a meses.
            </span>
          </div>
        )}

        <div className="campo">
          <label htmlFor="fecha">FECHA</label>
          {/* CAMPO ÚNICO DE FECHA DEL NÚCLEO (RF-149, D-240, RN-400): tocar
              cualquier parte abre el selector, no solo el icono del calendario.
              Las reglas de la fecha no cambian ni una (RN-405): el tope sigue
              siendo hoy y la fecha sigue siendo la local del dispositivo.
              ESTA ES LA ÚNICA PUERTA POR LA QUE EL 09 ENTRA A ESTE ARCHIVO, junto
              con el texto de la ayuda del campo de cuenta: el campo de IMPORTE de
              arriba está congelado y no se roza (D-229, D-241, RN-427, RN-452). */}
          <CampoDeFecha
            id="fecha"
            name="fecha"
            valor={fecha}
            max={hoy}
            alCambiar={alElegirFecha}
          />
          <span className="ayuda">
            Hoy ya viene puesta. Es la <b>fecha de tu dispositivo</b>, no la del servidor.
            Hacia atrás no hay límite dentro del calendario de meses; <b>hacia adelante no se
            permite</b>.
          </span>
        </div>

        <div className="campo">
          <label htmlFor="nota">NOTA (opcional)</label>
          <textarea
            id="nota"
            name="nota"
            maxLength={500}
            value={nota}
            onChange={(evento) => alEscribirNota(evento.target.value)}
          />
          <span className="ayuda">Hasta 500 caracteres. Es el texto que busca el filtro del historial.</span>
        </div>

        {ayuda}
      </div>
    </>
  );
}

/**
 * Saldos ya recalculados que devuelve el servidor tras guardar, más sus avisos.
 * SON AVISO, NUNCA ERROR (D-37, RN-082): el movimiento ya se guardó.
 */
export function SaldosAfectados({ resultado }) {
  if (!resultado) return null;

  return (
    <>
      <div className="card" style={{ margin: 12 }}>
        <h4 style={{ margin: '0 0 6px', fontSize: 11.5 }}>SALDOS YA RECALCULADOS</h4>
        {resultado.saldosAfectados.map((saldo) => (
          <div key={saldo.idCuenta} className="fila">
            <span className="crece">{saldo.nombreCuenta}{saldo.esCredito ? ' · deuda' : ''}</span>
            <b>{formatearImporte(saldo.esCredito ? saldo.deuda : saldo.saldo, saldo.codigoISO)}</b>
          </div>
        ))}
      </div>

      {resultado.avisoSobregiro && (
        <div className="aviso w">
          <b>Aviso, no error.</b> El movimiento <b>se guardó igual</b>: el saldo insuficiente y el
          sobregiro de una tarjeta <b>nunca bloquean la captura</b>.
        </div>
      )}

      {resultado.avisoPagoExcedido && (
        <div className="aviso w">
          <b>La tarjeta queda con saldo a favor.</b> Se permite y se guarda igual, pero mientras no
          vuelva a cero <b>esa tarjeta no se podrá desactivar</b>.
        </div>
      )}
    </>
  );
}
